import { Api } from '@/api';
import { GetClientsResponse } from '@/api/users';
import { useAppQuery } from '@/app-react-query';

const key = ['getMyAndTraineeClients'];
export const useGetMyAndTraineeClients = () => {
	return useAppQuery<GetClientsResponse, any>(key, Api.users.getMyAndTraineeClients);
};
useGetMyAndTraineeClients.getQueryKey = () => key;
